import React, { useCallback, useState } from 'react';

import LanguageInfoDialog from 'bundles/unified-description-page-common/components/modules/product-overview/LanguageInfoDialog';
import LanguageInfoDialogContext from 'bundles/unified-description-page-common/contexts/LanguageInfoDialogContext';
import getLanguagesMetadata from 'bundles/unified-description-page-common/utils/getLanguagesMetadata';

export type Languages = {
  primaryLanguages: string[];
  translatedLanguages: {
    code: string;
    isMachineTranslated: boolean;
  }[];
  subtitleLanguages: string[];
  // TODO: Refine type when hook up to real data
  // https://coursera.atlassian.net/browse/MERCH-1117
  dubbingLanguages?: string[] | null;
};

type Props = {
  languages?: Languages;
  children: React.ReactNode;
};

const LanguageInfoDialogProvider = ({ children, languages }: Props) => {
  const [isDialogOpen, setDialogOpen] = useState(false);

  const openDialog = useCallback<(...args: $TSFixMe[]) => $TSFixMe>(() => setDialogOpen(true), []);
  const closeDialog = useCallback<(...args: $TSFixMe[]) => $TSFixMe>(() => setDialogOpen(false), []);

  if (!languages) {
    return <>{children}</>;
  }

  const { autoTranslations, humanTranslations, subtitles, originalLanguage, dubbings } =
    getLanguagesMetadata(languages);

  return (
    <LanguageInfoDialogContext.Provider value={{ isDialogOpen, openDialog, closeDialog }}>
      {children}
      <LanguageInfoDialog
        open={isDialogOpen}
        onClose={closeDialog}
        originalLanguage={originalLanguage}
        autoTranslations={autoTranslations}
        humanTranslations={humanTranslations}
        subtitles={subtitles}
        dubbings={dubbings}
      />
    </LanguageInfoDialogContext.Provider>
  );
};

export default LanguageInfoDialogProvider;
